import React from 'react'

export const NoMatch = () => (
  <div> no match!</div>
)